import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Box, Flex, Image, Text } from '@chakra-ui/react';
import { LeaderboardStatPeriod, User, UserInPeriodLeaderboard } from 'models';
import { createLava } from 'utils/createLavaBubles';

const LeaderboardBanner = ({
  place = 0,
  totalPoints,
  users,
  stat,
}: {
  totalPoints: number | string;
  users: UserInPeriodLeaderboard[];
  stat: LeaderboardStatPeriod;
  place?: number;
}) => {
  const [searchParams] = useSearchParams();
  const pointsText = `you're #${place} with ${totalPoints}`;
  const text = (() => {
    if (searchParams.get('friends') === 'true') {
      if (users.findIndex((u) => u.user.id === stat.me?.user.id) > -1) {
        return pointsText;
      } else return 'my squad';
    } else if ((searchParams.get('friends') === 'false' && stat.me?.points !== null) || stat.me?.points !== undefined) {
      return pointsText;
    }

    return 'my squad';
  })();
  useEffect(() => {
    const timer = setTimeout(() => {
      createLava('bubble');
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Flex px="16px" py="12px">
      <Flex
        w="100%"
        h="130px"
        backgroundColor="#F83C3C"
        borderRadius="8px"
        flexDirection="column"
        justify="space-between"
        p="10px 12px"
        position="relative"
        overflow="hidden"
      >
        <Image
          src="/promo-hoodie.webp"
          alt="banner"
          w="265px"
          h="354px"
          objectPosition="center"
          objectFit="cover"
          position="absolute"
          top="-30px"
          right="-50px"
          zIndex="2"
        />
        <canvas
          id="bubble"
          style={{
            position: 'absolute',
            zIndex: 1,
            top: '-10px',
            left: '-10px',
            width: 'calc(100% + 20px)',
            height: 'calc(100% + 20px)',
            filter: 'blur(9px)',
          }}
        />
        <Text
          fontSize="20px"
          fontWeight="400"
          lineHeight="1.1"
          textTransform="uppercase"
          color="#fff"
          fontFamily="Antonio"
          zIndex="3"
        >
          PLACE #1 IN SEPTEMBER,
          <br />
          WIN CLUTCHPOINTS HOODIE
        </Text>
        <Text
          fontSize="11px"
          fontWeight="400"
          lineHeight="1.3"
          textTransform="uppercase"
          color="#fff"
          fontFamily="Special Gothic Expanded One"
          zIndex="3"
        >
          {text}
        </Text>
      </Flex>
    </Flex>
  );
};

export default LeaderboardBanner;
